<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <ChatWindow />
  </div>
</template>

<script>
import ChatWindow from '../components/ChatWindow.vue';

export default {
  name: 'app',
  components: {
    ChatWindow
  },
  data () {
    return {

    }
  }
}
</script>

<style>
#app {
  font-family: "MicrosoftYaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width:750px;
  margin:0 auto;
  background: #ffffff;
}
</style>




// WEBPACK FOOTER //
// src/App.vue